import React from 'react'

const TeamComponent = () => {
  return (
    <React.Fragment>
        <section id="c-heroAboutUs" className="c-sectionHero">
		<div className="container  pb-0">
			<div className="row">
				<div className="col-md-8 col-sm-12 c-heroContentCol">
					<div className="c-heroContent">
						<h5 className="c-heading46Bold">Our Team </h5>
						<p className="c-para22Regular">Meet an exceptional team of technology advisors, growth facilitators and subject matter experts with proven experience</p>
					
					</div>
				</div>
			
			</div>
		</div>
	</section>



	{/* <!-- Section team - Tabs --> */}
	<section id="c-sectionTeamTabs" className="c-sectionWrapper">
		<div className="container">
			<div className="c-aboutTabUlWrapper">
				<ul className="nav nav-tabs" id="c-aboutTab" role="tablist">
					<li className="nav-item" role="presentation">
						<a className="nav-link active" 
							id="abt-vision-tab" 						
							href="#abt-vision" data-toggle="tab"  role="tab" 
							aria-controls="abt-vision" aria-selected="true">All</a>
					</li>
					<li className="nav-item" role="presentation">
						<a className="nav-link" 
							id="abt-mission-tab" 
							href="#abt-mission" data-toggle="tab" role="tab" 
							aria-controls="abt-mission" aria-selected="false">Founding Members</a>
					</li>
					<li className="nav-item" role="presentation">
						<a className="nav-link" 
							id="abt-values-tab" 
							href="#abt-values" data-toggle="tab" role="tab" 
							aria-controls="abt-values" aria-selected="false">Advisor & Mentor</a>
					</li>
					
						<li className="nav-item" role="presentation">
						<a className="nav-link" 
							id="abt-tech-tab" 
							href="#abt-tech" data-toggle="tab" role="tab" 
							aria-controls="abt-tech" aria-selected="false">Tech & Design</a>
					</li>

					<li className="nav-item dropdown">
						<a className="nav-link dropdown-toggle active" data-toggle="dropdown" href="#" role="button" aria-expanded="false">All</a>
						<div className="dropdown-menu">
							<a className="dropdown-item active" href="#abt-vision" data-toggle="tab"  role="tab" 
								aria-controls="abt-vision">All</a>
							<a className="dropdown-item" href="#abt-mission" data-toggle="tab" role="tab" 
								aria-controls="abt-mission">Board Members</a>
							<a className="dropdown-item" href="#abt-values" data-toggle="tab" role="tab" 
								aria-controls="abt-values">Advisor & Mentor</a>	
                                <div className="dropdown-item" href="#abt-tech" data-toggle="tab" role="tab" 
								aria-controls="abt-values">Tech & Design </div>                            
                                </div>	
					</li>
				</ul>
			</div>
			<div className="tab-content  team-section pt-40" id="c-aboutTabContent">
				<div className="tab-pane fade show active" id="abt-vision" role="tabpanel" 
					aria-labelledby="abt-vision-tab">
					<h3>Board Members</h3>
					
					<div className="flex_wrapper space_between">
            <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team1.png" />
                <div className='overlay'>
                    <div className='text'>Brajendra CEO</div>
                </div>
                </figure>
                <div className="team_desc">
                <div className="heading5">Brajendra</div>
                <div className="team_designation">Founder & CEO</div>
                </div>
            </div>
            <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team3.png" />
                <div className='overlay'>
                    <div className='text'>Kamal CTO</div>
                </div>
                </figure>
                <div className="team_desc">
                <div className="heading5">Kamal</div>
                <div className="team_designation">CTO</div>
                </div>
            </div>
            <div className="team_image">
                <figure className="team2">
                <img src="./images/team/team2.png" />
                <div className='overlay'>
                    <div className='text'>Rakesh COO</div>
                </div>
                </figure>
                <div className="team_desc">
                 <div className="heading5">Rakesh</div>
                <div className="team_designation">COO</div>
                </div>
            </div>
            <div className="team_image">
                <figure className="team3">
               <img src="./images/team/team4.png" />
               <div className='overlay'>
                    <div className='text'>Yogesh CAO</div>
                </div>
                </figure>
                <div className="team_desc">
                <div className="heading5">Yogesh</div>
                <div className="team_designation">CAO</div>
                </div>
            </div>
          
            <div className="team_image"></div>
        </div>
		
		<h3>Advisor & Mentor</h3>
		<div className="flex_wrapper space_between">
            <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team2.png" />
                <div className='overlay'>
                    <div className='text'>Sanjay Thakur</div>
                </div>
                </figure>
                <div className="team_desc">
                <div className="heading5">Sanjay Thakur</div>
                <div className="team_designation">Mentor & Advisor</div>
                </div>
            </div>
            <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team2.png" />
                <div className='overlay'>
                    <div className='text'>Ashok Mittal</div>
                </div>
                </figure>
                <div className="team_desc">
                <div className="heading5">Ashok Mittal</div>
                <div className="team_designation">Mentor & Advisor</div>
                </div>
            </div>
			
			 <div className="team_image">
                <figure className="team1">
                <img src="./images/team/blank.png" />
                </figure>
                <div className="team_desc">
                
                </div>
            </div>
			
			 <div className="team_image">
                <figure className="team1">
                <img src="./images/team/blank.png" />
                </figure>
                <div className="team_desc">
               
                </div>
            </div>
            
          
            <div className="team_image"></div>
        </div>
		
		<h3>Technology & Design</h3>
		<div className="flex_wrapper space_between">
        
            {/* <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team5.png" />
                <div className='overlay'>
                    <div className='text'>Malik</div>
                </div>
                </figure>
                <div className="team_desc">
                <div className="heading5">Malik</div>
                <div className="team_designation">Java Developer</div>
                </div>
            </div> */}
			  <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team6.png" />
                {/* <div className='overlay'>
                    <div className='text'>Arvind</div>
                </div> */}
                </figure>
                <div className="team_desc">
                <div className="heading5">Arvind</div>
                <div className="team_designation">Java Developer</div>
                </div>
            </div>
			  <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team7.png" />
                {/* <div className='overlay'>
                    <div className='text'>Rajiv</div>
                </div> */}
                </figure>
                <div className="team_desc">
                <div className="heading5">Rajiv</div>
                <div className="team_designation">UI/UX Designer</div>
                </div>
            </div>
            <div className="team_image">
                <figure className="team1">
                <img src="./images/team/blank.png" />
                </figure>
                <div className="team_desc">          
                </div>
            </div>          
            <div className="team_image">
			</div>
        </div>
		
		<h3>HR and Sales</h3>
		<div className="flex_wrapper space_between">
        
            <div className="team_image">
                <figure className="team1">
                <img src="./images/team/hr1.png" />
                {/* <div className='overlay'>
                    <div className='text'>Meenakshi</div>
                </div> */}
                </figure>
                <div className="team_desc">
                <div className="heading5">Meenakshi</div>
                <div className="team_designation">HR</div>
                </div>
            </div>
			  {/* <div className="team_image">
                <figure className="team1">
                <img src="./images/team/hr2.png" />
                <div className='overlay'>
                    <div className='text'>Nikita</div>
                </div> 
                </figure>
                <div className="team_desc">
                <div className="heading5">Nikita</div>
                <div className="team_designation">HR</div>
                </div>
            </div> */}
			  <div className="team_image">
                <figure className="team1">
                <img src="./images/team/hr3.png" />
                {/* <div className='overlay'>
                    <div className='text'>Sadiya</div>
                </div> */}
                </figure>
                <div className="team_desc">
                <div className="heading5">Sadiya</div>
                <div className="team_designation">Business Development</div>
                </div>
            </div>
            <div className="team_image">
                <figure className="team1">
                <img src="./images/team/blank.png" />
                </figure>
                <div className="team_desc">          
                </div>
            </div>          
            <div className="team_image">
			</div>
        </div>
					
				</div>
				<div className="tab-pane fade" id="abt-mission" role="tabpanel" 
					aria-labelledby="abt-mission-tab">
					<h3>Board Members</h3>
					
					<div className="flex_wrapper space_between">
            <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team1.png" />
                <div className='overlay'>
                    <div className='text'>Brajendra CEO</div>
                </div>
                </figure>
                <div className="team_desc">
                <div className="heading5">Brajendra</div>
                <div className="team_designation">Founder & CEO</div>
                </div>
            </div>
            <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team2.png" />
                <div className='overlay'>
                    <div className='text'>Kamal CTO</div>
                </div>
                </figure>
                <div className="team_desc">
                <div className="heading5">Kamal</div>
                <div className="team_designation">CTO</div>
                </div>
            </div>
            <div className="team_image">
                <figure className="team2">
                <img src="./images/team/team3.png" />
                <div className='overlay'>
                    <div className='text'>Rakesh COO</div>
                </div>
                </figure>
                <div className="team_desc">
                 <div className="heading5">Rakesh</div>
                <div className="team_designation">COO</div>
                </div>
            </div>
            <div className="team_image">
                <figure className="team3">
               <img src="./images/team/team4.png" />
               <div className='overlay'>
                    <div className='text'>Yogesh CAO</div>
                </div>
                </figure>
                <div className="team_desc">
                <div className="heading5">Yogesh</div>
                <div className="team_designation">CAO</div>
                </div>
            </div>
          
            <div className="team_image"></div>
        </div>
				</div>
				<div className="tab-pane fade" id="abt-values" role="tabpanel" 
					aria-labelledby="abt-values-tab">
						<h3>Advisor & Mentor</h3>
		<div className="flex_wrapper space_between">
            <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team2.png" />
                <div className='overlay'>
                    <div className='text'>Sanjay Thakur</div>
                </div>
                </figure>
                <div className="team_desc">
                <div className="heading5">Sanjay Thakur</div>
                <div className="team_designation">Mentor & Advisor</div>
                </div>
            </div>
            <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team2.png" />
                <div className='overlay'>
                    <div className='text'>Ashok Mittal</div>
                </div>
                </figure>
                <div className="team_desc">
                <div className="heading5">Ashok Mittal</div>
                <div className="team_designation">Mentor & Advisor</div>
                </div>
            </div>
			
			 <div className="team_image">
                <figure className="team1">
                <img src="./images/team/blank.png" />
                </figure>
                <div className="team_desc">
                
                </div>
            </div>
			
			 <div className="team_image">
                <figure className="team1">
                <img src="./images/team/blank.png" />
                </figure>
                <div className="team_desc">
               
                </div>
            </div>
            <div className="team_image"></div>
        </div>
				</div>
				
					<div className="tab-pane fade" id="abt-tech" role="tabpanel" 
					aria-labelledby="abt-tech-tab">
						<h3>Technology & Design</h3>
		 <div className="flex_wrapper space_between">
        
           {/*  <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team5.png" />
                {/* <div className='overlay'>
                    <div className='text'>Malik</div>
                </div> 
                </figure>
                <div className="team_desc">
                <div className="heading5">Malik</div>
                <div className="team_designation">Java Developer</div>
                </div>
            </div> */}
			  <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team6.png" />
                {/* <div className='overlay'>
                    <div className='text'>Arvind</div>
                </div> */}
                </figure>
                <div className="team_desc">
                <div className="heading5">Arvind</div>
                <div className="team_designation">Java Developer</div>
                </div>
            </div>
			  <div className="team_image">
                <figure className="team1">
                <img src="./images/team/team7.png" />
                {/* <div className='overlay'>
                    <div className='text'>Rajiv</div>
                </div> */}
                </figure>
                <div className="team_desc">
                <div className="heading5">Rajiv</div>
                <div className="team_designation">UI/UX Designer</div>
                </div>
            </div>
            <div className="team_image">
                <figure className="team1">
                <img src="./images/team/blank.png" />
                </figure>
                <div className="team_desc">          
                </div>
            </div>          
            <div className="team_image">
			</div>
        </div>
				</div>
				
				
			</div>
		</div>
	</section>
    </React.Fragment>
  )
}

export default TeamComponent